// Teller Online Library Files
import {
    TellerOnlineAppService,
    TellerOnlineRailNavigationService
} from 'teller-online-libraries/core';

/**
 * True while the navigation rail is on screen: it has navigation (the user is signed in) and the
 * screen is wide. One function, read by the app shell that renders the rail and by the header
 * that hands its current markers to it, so the two cannot drift apart.
 */
export function isRailShowing(
    railNavigationService: TellerOnlineRailNavigationService,
    appService: TellerOnlineAppService
): boolean {
    return railNavigationService.enabled() && appService.isWide;
}
